import { type ComponentProps, useContext } from "react";
import { classNames } from "../../utils/classNames";
import { MessageContext } from "./Message";

export function MessageTitle({ className, ...props }: ComponentProps<"span">) {
  const context = useContext(MessageContext) ?? {};
  if (!context) {
    throw new Error("MessageTitle must be used within a Message");
  }

  return (
    <span {...props} className={classNames("text-sm/5 font-bold", className)} />
  );
}
